import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export interface MostRecommendedProduct {
    _id: string;
    type: 'defensive' | 'fertilizer';
    name: string;
    nature?: string;
    manufacturer?: string;
    avatars: string[];
    totalRecommendations: number;
}

export const useGetMostRecommendedProduct = () => {
    return useQuery<MostRecommendedProduct | null>({
        queryKey: ['data-reports', 'mostRecommendedProduct'],
        queryFn: async () => (await api.get('/data-reports/most-recommended-product')).data,
    });
};
